import { DotsButton } from "@atoms/DotsButton";
import type { TTestimonialNavigator } from "./types";

export const TestimonialNavigator = ({
  currentCardIndex,
  lastIndexArray,
  onClickButton,
}: TTestimonialNavigator) => {
  const TestimonialNavigatorElement = document.createElement("div");
  TestimonialNavigatorElement.className = "flex items-center gap-2 pr-6";

  [...Array(lastIndexArray + 1)].forEach((_, indexButton) => {
    TestimonialNavigatorElement.appendChild(
      DotsButton({
        active: indexButton === currentCardIndex,
        onClick: () => onClickButton(indexButton),
      }),
    );
  });

  return TestimonialNavigatorElement;
};
